<template>
	<el-drawer :modal="false" :visible.sync="showSearchMessageDrawer" class="search-message-drawer" size="45%"
		title="Search Messages">
		<div class="search-messages">
			<b-container>
				<el-input placeholder="Search..." v-model="searchText" clearable>
					<el-button slot="append" icon="el-icon-search" @click="searchAll" :disabled="searchText === ''"></el-button>
				</el-input>

				<b-row>
					<b-col cols="12">
						<el-tabs class="m-3">
							<el-tab-pane label="All">
								<div v-loading="loading">
									<message-searched v-for="(message, index) in searchedMessages" :message="message"
										:key="index"></message-searched>
									<div class="d-flex justify-content-center mt-3 mb-5" v-if="searchedMessagesPagination">
										<b-button variant="outline-primary" @click="getMoreSearchedMessages" v-if="!disableLoadMore">Load
											More</b-button>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="Unread" disabled>
								Search Unread Message
							</el-tab-pane>
							<el-tab-pane label="Mentioned Me">
								<!-- <message-searched></message-searched> -->
								<div v-if="searchedMentionedMessages.length > 0">
									<message-searched v-for="(mentioned, index) in searchedMentionedMessages" :message="mentioned"
										:key="index"></message-searched>
								</div>
								<span v-else>There's no message mentioning you</span>
							</el-tab-pane>
						</el-tabs>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</el-drawer>
</template>
<script>
import { Drawer, Input, Button, Tabs, TabPane } from 'element-ui'
import MessageSearched from '@/views/Messaging/MessageSearched'
import { mapState, mapActions } from 'pinia'
import { useConfigStore } from '@/stores/configStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { useAuthStore } from '@/stores/authStore'
import { axios, services, getHeader } from '@/assets/js/httpImports.js'

export default {
	components: {
		MessageSearched,
		[Drawer.name]: Drawer,
		[Input.name]: Input,
		[Button.name]: Button,
		[Tabs.name]: Tabs,
		[TabPane.name]: TabPane,
	},
	data() {
		return {
			showSearchMessageDrawer: false,
			searchText: '',
			loading: false,
			searchedMessages: [],
			searchedMentionedMessages: [],
			searchedMessagesPagination: null
		}
	},
	computed: {
		...mapState(useMessagingStore, ['selected_group']),
		...mapState(useConfigStore, ['app_code']),
		...mapState(useAuthStore, ['auth_user']),
		disableLoadMore() {
			return Number(this.searchedMessagesPagination.page) >= Number(this.searchedMessagesPagination.total_page) - 1;
		}
	},
	methods: {
		...mapActions(useMessagingStore, ['getGroupMessage', 'showOnlyFromDate']),
		viewSearchMessageDrawer() {
			this.showSearchMessageDrawer = !this.showSearchMessageDrawer
		},
		searchAll() {
			this.loading = true

			let urlSearchParams = new URLSearchParams()
			urlSearchParams.append('is_full_content', true)
			urlSearchParams.append('pagination[page]', 0)
			urlSearchParams.append('pagination[limit]', 5)
			urlSearchParams.append('pagination[order][message_id]', "DESC")
			urlSearchParams.append('search[message_group_id]', this.selected_group?.group_id || null)
			urlSearchParams.append('search[message_content]', this.searchText)
			urlSearchParams.append('search[message_application_code]', this.app_code)
			urlSearchParams.append('search[message_from_date]', this.showOnlyFromDate())
			// urlSearchParams.append('search[search_replies]', false)

			// urlSearchParams.append('search[search_mention]', this.app_code)
			// urlSearchParams.append('search[search_unread]', this.app_code)
			// urlSearchParams.append('search[current_user_id]', this.app_code)

			let url = `${services.messaging}messages?${urlSearchParams.toString()}`
			axios.get(url, { headers: getHeader() })
				.then(res => {
					this.searchedMessages = res.data.content
					this.searchedMessagesPagination = res.data.pagination
					this.loading = false
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Search Message Drawer (searchAll) failed:' + e.response.data.message)
				})
		},
		searchMentioned() {
			this.loading = true

			let urlSearchParams = new URLSearchParams()
			urlSearchParams.append('is_full_content', true)
			urlSearchParams.append('pagination[page]', 0)
			urlSearchParams.append('pagination[limit]', 5)
			urlSearchParams.append('pagination[order][message_id]', "DESC")
			urlSearchParams.append('search[message_group_id]', this.selected_group?.group_id || null)
			urlSearchParams.append('search[message_content]', this.searchText)
			urlSearchParams.append('search[message_application_code]', this.app_code)
			urlSearchParams.append('search[search_mention]', true)
			urlSearchParams.append('search[current_user_id]', this.auth_user.id)
			urlSearchParams.append('search[message_from_date]', this.showOnlyFromDate())
			// urlSearchParams.append('search[search_replies]', false)
			// urlSearchParams.append('search[search_unread]', this.app_code)

			let url = `${services.messaging}messages?${urlSearchParams.toString()}`
			axios.get(url, { headers: getHeader() })
				.then(res => {
					this.searchedMentionedMessages = res.data.content
					this.searchedMessagesPagination = res.data.pagination
					this.loading = false
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Search Message Drawer (searchAll) failed:' + e.response.data.message)
				})
		},
		getMoreSearchedMessages() {
			this.searchedMessagesPagination.page++
			let urlSearchParams = new URLSearchParams();
			urlSearchParams.append('is_full_content', true);
			urlSearchParams.append('pagination[page]', this.searchedMessagesPagination.page);
			urlSearchParams.append('pagination[limit]', 5);
			urlSearchParams.append('pagination[order][message_id]', "DESC");
			urlSearchParams.append('search[message_group_id]', this.selected_group?.group_id || null);
			urlSearchParams.append('search[message_content]', this.searchText);
			urlSearchParams.append('search[message_application_code]', this.app_code);
			urlSearchParams.append('search[message_from_date]', this.showOnlyFromDate())

			let url = `${services.messaging}messages?${urlSearchParams.toString()}`;
			axios.get(url, { headers: getHeader() })
				.then(res => {
					this.searchedMessages = this.searchedMessages.concat(res.data.content)
					this.searchedMessagesPagination = res.data.pagination
				})
				.catch(e => {
					_gNotif.errorFunction(e)
					_gNotif.cLog('Messaging Store (getMoreMessages) failed:' + e.response.data.message)
				})
		},
	}
}
</script>